var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[_c('v-container',{staticClass:"d-flex flex-column",staticStyle:{"height":"100%","padding":"0px","min-height":"inherit","max-width":"1500px"},attrs:{"fluid":""}},[_c('h1',{staticClass:"head"},[_vm._v("Please wait for admin approval/confirmation")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }